/* global google, eraGoogleMapsData */

/* eslint-disable */
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
	key: eraGoogleMapsData.maps_api_key,
	v: 'quarterly'
});
/* eslint-enable */

const whenMapsReady = (() => {
	let ready;
	return () => {
		if ( typeof window.google === 'undefined' ) {
			return Promise.reject( new Error( 'Google Maps loader not found on page' ) );
		}
		if ( ! ready ) {
			ready = (async () => {
				await google.maps.importLibrary( 'maps' );
				return google;
			})();
		}
		return ready;
	};
})();
window.eraWhenMapsReady = whenMapsReady;

window.eraGoogleMaps = {
	data: window.eraGoogleMapsData,
	mapMarkers: [],
	mapSettings: {},
	map: null,
	mapContainer: null,
	editingUid: null,
	customMarkerMapping: [],
	linesMapping: [],
	lineIconsMapping: [],
	isBuilder: false,

	async initBuilder( args = {} ) {
		console.log( 'init builder' );

		try {
			await whenMapsReady();
		} catch ( e ) {
			console.warn( 'Maps not available:', e );
			return;
		}

		this.mapMarkers = args.mapMarkers;
		this.mapSettings = args.mapSettings;
		this.mapContainer = args.mapContainer;
		this.isBuilder = true;

		const mapOptions = this.getMapOptions();
		this.map = new google.maps.Map( this.mapContainer, mapOptions );
		this.placeMarkers( this.mapMarkers );

		this.map.addListener( 'zoom_changed', () => this.mapSettingsChanged() );
		this.map.addListener( 'center_changed', () => this.mapSettingsChanged() );
		this.map.addListener( 'click', ( e ) => {
			if ( this.editingUid ) {
				this.updateMapMarker( this.editingUid, e.latLng.lat(), e.latLng.lng() );
			}
		} );
	},

	async initFrontend() {
		const mapElements = document.querySelectorAll( '[data-google-map]' );
		if ( ! mapElements.length ) return;

		try {
			await whenMapsReady();
		} catch ( e ) {
			console.warn( 'Maps not available:', e );
			return;
		}

		// Each map element gets its own instance so multiple maps on the same
		// page don't share state (the map object, markers, lines, etc.).
		mapElements.forEach( ( mapElement ) => {
			const instance = Object.create( window.eraGoogleMaps );
			instance.mapMarkers = [];
			instance.mapSettings = {};
			instance.customMarkerMapping = [];
			instance.linesMapping = [];
			instance.lineIconsMapping = [];
			instance.map = null;
			instance.isBuilder = false;
			instance.renderFrontend( mapElement );
		} );
	},

	renderFrontend( mapElement ) {
		this.mapSettings.zoom = parseInt( mapElement.getAttribute( 'data-zoom' ) ) || 14;
		this.mapSettings.centerLat = parseFloat( mapElement.getAttribute( 'data-center-lat' ) ) || 0;
		this.mapSettings.centerLng = parseFloat( mapElement.getAttribute( 'data-center-lng' ) ) || 0;
		const mapOptions = this.getMapOptions();
		this.map = new google.maps.Map( mapElement, mapOptions );
		this.mapMarkers = JSON.parse( mapElement.getAttribute( 'data-markers' ) || '[]' );
		let counter = 0;
		this.mapMarkers.map( item => {
			item.uid = counter;
			counter++;
			return item;
		} );
		this.placeMarkers();
	},

	/**
	 * Update map marker by uid.
	 *
	 * @param uid
	 * @param newLat
	 * @param newLng
	 */
	updateMapMarker( uid, newLat, newLng ) {
		const editingMapMarker = this.mapMarkers.find( item => item.uid === uid );
		editingMapMarker.lat = newLat;
		editingMapMarker.lng = newLng;

		const lineIn = this.linesMapping.find( item => item.to === uid );
		const lineOut = this.linesMapping.find( item => item.from === uid );
		if ( typeof lineIn !== 'undefined' ) {
			this.updateLinePosition( lineIn );
		}
		if ( typeof lineOut !== 'undefined' ) {
			this.updateLinePosition( lineOut );
		}

		const customMarker = this.customMarkerMapping.find( item => item.uid === uid );
		if ( typeof customMarker !== 'undefined' ) {
			// If marker already exists, set its new position.
			customMarker.setPosition( new google.maps.LatLng( newLat, newLng ) );
		} else {
			// If the marker does not exist, create marker and line from previous marker.

			// The else statement should only be hit when a new marker is added. If that is the case, the last marker
			// will already have been added to this.mapMarkers, and the marker before it is the length of the array - 2.
			const previousMarker = this.mapMarkers[this.mapMarkers.length - 2];
			this.placeMarker( {
				uid,
				lat: newLat,
				lng: newLng,
				title: '',
				titlePosition: editingMapMarker.titlePosition,
				icon: '',
				iconRotation: ''
			}, true );
			if ( previousMarker ) {
				const newLine = this.drawLine( {
					start: { lat: parseFloat(previousMarker.lat), lng: parseFloat(previousMarker.lng) },
					end: { lat: newLat, lng: newLng },
					map: this.map,
					startMarker: previousMarker
				} );
				this.linesMapping.push( {
					to: uid,
					from: previousMarker.uid,
					line: newLine.line,
					path: newLine.path
				} );
			}
		}

		const event = new CustomEvent( 'markerChanged', { detail: { uid } } );
		document.dispatchEvent( event );
	},

	/**
	 * Update settings object on map update events.
	 *
	 * Dispatch event to document to let other scripts listen for changes.
	 */
	mapSettingsChanged() {
		this.mapSettings.zoom = this.map.get( 'zoom' );
		this.mapSettings.centerLat = this.map.get( 'center' ).lat();
		this.mapSettings.centerLng = this.map.get( 'center' ).lng();
		const event = new Event( 'mapSettingsChanged' );
		document.dispatchEvent( event );
	},

	/**
	 * Update a line.
	 *
	 * This method is called when a marker position is changed,
	 * and the line's "from" and "to" props needs to be moved.
	 *
	 * @param line
	 */
	updateLinePosition( line ) {
		const fromMarker = this.mapMarkers.find( item => item.uid === line.from );
		const toMarker = this.mapMarkers.find( item => item.uid === line.to );

		// Remove line from map.
		line.line.setMap( null );

		// Draw a new line with positions from the from and to markers.
		const newLine = this.drawLine( {
			start: { lat: parseFloat(fromMarker.lat), lng: parseFloat(fromMarker.lng) },
			end: { lat: parseFloat(toMarker.lat), lng: parseFloat(toMarker.lng) },
			map: this.map,
			startMarker: fromMarker
		} );

		// Update linesMapping with new line data.
		line.line = newLine.line;
		line.path = newLine.path;

		//  If the line had an icon, update it.
		const customLineIcon = this.lineIconsMapping.find( item => item.uid === fromMarker.uid );
		if ( typeof customLineIcon !== 'undefined' ) {
			const position = Object.hasOwn( fromMarker, 'lineIconPosition' ) ? fromMarker.lineIconPosition : 50;
			const lineIconPosition = this.getPointByPercentage( newLine.path, position );
			customLineIcon.setPosition( lineIconPosition );
		}
	},

	/**
	 * Update the map from this.mapSettings.
	 */
	updateMap() {
		// Accessing the values directly in the setCenter method does not work for some reason.
		// So we extract them first, then use them.
		const lat = this.mapSettings.centerLat;
		const lng = this.mapSettings.centerLng;

		this.map.set( 'zoom', this.mapSettings.zoom );
		this.map.setCenter( { lat, lng } );
	},

	/**
	 * Set the item being edited by uid.
	 *
	 * @param uid
	 */
	startEditing( uid ) {
		this.editingUid = uid;
		const currentEdit = this.customMarkerMapping.find( item => item.uid === this.editingUid );
		if ( currentEdit ) {
			currentEdit.setEditingMarker( true );
		}
	},

	/**
	 * Clear item being edited.
	 */
	endEditing() {
		const currentEdit = this.customMarkerMapping.find( item => item.uid === this.editingUid );
		if ( currentEdit ) {
			currentEdit.setEditingMarker( false );
		}
		this.editingUid = null;
	},

	/**
	 * Redraw all lines.
	 *
	 * Method called when deleting or sorting.
	 */
	redrawLines() {
		// Remove all lines from the map.
		this.linesMapping.forEach( line => {
			line.line.setMap( null );
		} );

		// Empty the this.linesMapping array.
		this.linesMapping.length = 0;
		const markerPositions = [];

		// Generate an array map of marker positions.
		this.mapMarkers.forEach( ( marker, index ) => {
			markerPositions.push( {
				position: { lat: marker.lat, lng: marker.lng },
				startMarker: marker
			} );
		} );

		// Draw lines from markerPositions.
		this.drawLines( markerPositions, this.map );

		// Get the new last item.
		const last = markerPositions[markerPositions.length - 1];

		// Check if the now last item, had a line icon and remove it if so.
		const lineIconIndex = this.lineIconsMapping.findIndex( item => item.uid === last.startMarker.uid );
		if ( lineIconIndex in this.lineIconsMapping ) {
			this.lineIconsMapping[lineIconIndex].remove();
			this.lineIconsMapping.splice( lineIconIndex, 1 );
		}
	},

	/**
	 * Add all markers from this.mapMarkers to map.
	 */
	placeMarkers() {
		const markerPositions = [];
		this.mapMarkers.forEach( ( markerData ) => {
			markerPositions.push( this.placeMarker( markerData ) );
		} );

		// Draw associated lines between markers.
		if ( markerPositions.length > 1 ) {
			this.drawLines( markerPositions );
		}
	},

	/**
	 * Add marker to map from markerData
	 *
	 * @param markerData
	 * @param editing
	 * @returns {{position: {lat: number, lng: number}, startMarker}}
	 */
	placeMarker( markerData, editing = false ) {
		const position = {
			position: {
				lat: parseFloat( markerData.lat ),
				lng: parseFloat( markerData.lng )
			},
			startMarker: markerData
		};

		const customMarker = this.createCustomMarker(
			{
				instance: this,
				uid: markerData.uid || null,
				map: this.map,
				position: position.position,
				title: markerData.title || '',
				titlePosition: markerData.titlePosition || '',
				subtitle: markerData.subtitle || '',
				hideMarker: markerData.hideMarker || false,
				hideTitle: markerData.hideTitle || false,
				icon: markerData.icon || '',
				iconRotation: markerData.iconRotation || '',
				iconFlip: markerData.iconFlip || false,
				iconOffsetX: markerData.iconOffset?.x || 0,
				iconOffsetY: markerData.iconOffset?.y || 0,
				editing
			}
		);
		if ( Object.hasOwn( markerData, 'uid' ) ) {
			this.customMarkerMapping.push( customMarker );
		}
		return position;
	},

	/**
	 * Draw lines from array of marker postions.
	 *
	 * @param markerPositions
	 */
	drawLines( markerPositions ) {
		// .length - 1, to skip the last element, as it does not have a
		// "next" and was already used in the second to last.
		for ( let i = 0; i < markerPositions.length - 1; i++ ) {
			// Get current and next marker.
			const start = markerPositions[i];
			const end = markerPositions[i + 1];

			const curvedPolyline = this.drawLine( {
				start: start.position,
				end: end.position,
				startMarker: markerPositions[i].startMarker
			} );

			if ( ! curvedPolyline ) {
				continue;
			}
			this.linesMapping.push( {
				from: start.startMarker.uid,
				to: end.startMarker.uid,
				line: curvedPolyline.line,
				path: curvedPolyline.path
			} );

			curvedPolyline.line.setMap( this.map );

			this.updateLineIcon( markerPositions[i].startMarker.uid, curvedPolyline.path );
		}
	},

	/**
	 * Draw line.
	 *
	 * @param args
	 * @returns {{line: google.maps.Polyline, path: *[]}}
	 */
	drawLine( args ) {
		const curvePath = this.createBezierCurve( {
			start: args.start,
			end: args.end,
			curve: Object.hasOwn( args.startMarker, 'lineCurve' ) ? args.startMarker.lineCurve : 0
		} );

		const lineDashed = {
			path: 'M 0,-1 0,1',
			strokeOpacity: 0.9,
			strokeWeight: 2,
			strokeColor: '#3A3A3A',
			scale: 3
		};

		const lineArgs = {
			path: curvePath,
			geodesic: true,
			strokeColor: '#3A3A3A',
			strokeOpacity: 0.9,
			strokeWeight: 2,
			icons: []
		};

		if ( args.startMarker.lineType === '' ) {
			lineArgs.strokeOpacity = 0;
			lineArgs.path = [{ lat: args.start.lat, lng: args.start.lng }, { lat: args.end.lat, lng: args.end.lng }];
		}

		if ( args.startMarker.lineType === 'dashed' ) {
			lineArgs.strokeOpacity = 0;
			lineArgs.icons.push( {
				icon: lineDashed,
				offset: 0,
				repeat: '15px'
			} );
		}

		const curvedPolyline = new google.maps.Polyline( lineArgs );
		if ( args.startMarker.lineType === '' ) {
			curvedPolyline.setMap( null );
		} else {
			curvedPolyline.setMap( this.map );
		}
		return {
			line: curvedPolyline,
			path: curvePath
		};
	},

	updateLineIcon( uid, linePath ) {
		const thisMarker = this.mapMarkers.find( item => item.uid === uid );
		const customLineIconIndex = this.lineIconsMapping.findIndex( item => item.uid === uid );
		let customLineIcon = this.lineIconsMapping[customLineIconIndex];
		const hasIcon = thisMarker.lineIcon !== '' && typeof thisMarker.lineIcon !== 'undefined' && thisMarker.lineIcon !== null;
		if ( hasIcon && thisMarker.lineType !== '' ) {
			const position = typeof thisMarker.lineIconPosition !== 'undefined' ? thisMarker.lineIconPosition : 50;
			const lineIconPosition = this.getPointByPercentage( linePath, position );
			if ( typeof customLineIcon !== 'undefined' ) {
				customLineIcon.setIcon( thisMarker.lineIcon );
				customLineIcon.setPosition( lineIconPosition );
				customLineIcon.setIconRotation( thisMarker.lineIconRotation );
				customLineIcon.setIconFlip( thisMarker.lineIconFlip );
				customLineIcon.setIconOffset( thisMarker.lineIconOffset?.x || 0, thisMarker.lineIconOffset?.y || 0 );
			} else {
				customLineIcon = this.createCustomMarker(
					{
						instance: this,
						uid,
						map: this.map,
						position: lineIconPosition,
						icon: thisMarker.lineIcon,
						iconRotation: thisMarker.lineIconRotation,
						iconFlip: thisMarker.lineIconFlip,
						divClasses: ['era-map-marker--line-icon'],
						iconOffsetX: thisMarker.lineIconOffsetX,
						iconOffsetY: thisMarker.lineIconOffsetY
					}
				);
				this.lineIconsMapping.push( customLineIcon );
			}
		} else {
			if ( customLineIconIndex in this.linesMapping ) {
				customLineIcon.remove();
				this.lineIconsMapping.splice( customLineIconIndex, 1 );
			}
		}
	},

	updateLine( uid ) {
		const thisMarker = this.mapMarkers.find( item => item.uid === uid );
		const thisLineIndex = this.linesMapping.findIndex( item => item.from === uid );
		let path = [];
		if ( thisMarker.lineType !== '' ) {
			const toMarker = this.mapMarkers.find( item => item.uid === this.linesMapping[thisLineIndex].to );
			const newLine = this.drawLine( {
					start: { lat: parseFloat(thisMarker.lat), lng: parseFloat(thisMarker.lng) },
					end: { lat: parseFloat(toMarker.lat), lng: parseFloat(toMarker.lng) },
					map: this.map,
					startMarker: thisMarker
				}
			);
			this.linesMapping[thisLineIndex].line.setMap( null );
			this.linesMapping[thisLineIndex].line = newLine.line;
			this.linesMapping[thisLineIndex].path = newLine.path;
			path = newLine.path;
		} else {
			if ( thisLineIndex in this.linesMapping ) {
				this.linesMapping[thisLineIndex].line.setMap( null );
			}
		}
		this.updateLineIcon( uid, path );
	},

	/**
	 * Update a map marker.
	 *
	 * @param uid
	 * @param args
	 */
	updateCustomMarker( uid, args ) {
		const customMarker = this.customMarkerMapping.find( item => item.uid === uid );
		const mapMarker = this.mapMarkers.find( item => item.uid === uid );
		if ( typeof customMarker !== 'undefined' ) {
			for ( const [prop, value] of Object.entries( args ) ) {
				switch ( prop ) {
					case 'title':
						customMarker.setTitle( value );
						break;
					case 'titlePosition':
						customMarker.setTitlePosition( value );
						break;
					case 'subtitle':
						customMarker.setSubtitle( value );
						break;
					case 'hideTitle':
						customMarker.setHideTitle( value );
						break;
					case 'hideMarker':
						customMarker.setHideMarker( value );
						break;
					case 'icon':
						customMarker.setIcon( value );
						break;
					case 'iconRotation':
						customMarker.setIconRotation( value );
						break;
					case 'iconOffsetX':
					case 'iconOffsetY':
						customMarker.setIconOffset( mapMarker.iconOffsetX || 0, mapMarker.iconOffsetY || 0 );
						break;
					case 'iconOffset':
						customMarker.setIconOffset( mapMarker.iconOffset.x || 0, mapMarker.iconOffset.y || 0 );
						break;
					case 'iconFlip':
						customMarker.setIconFlip( value );
						break;
				}
			}
		}
	},

	/**
	 * Remove a map marker and all it associated icons and lines.
	 *
	 * @param uid
	 */
	removeMarker( uid ) {
		// Get indices of all the items associated with the map markers.
		const mapMarkerIndex = this.mapMarkers.findIndex( item => item.uid === uid );
		const customMarkerIndex = this.customMarkerMapping.findIndex( item => item.uid === uid );
		const lineMappingFromIndex = this.linesMapping.findIndex( item => item.from === uid );
		const lineMappingToIndex = this.linesMapping.findIndex( item => item.to === uid );
		const lineIconsMappingIndex = this.lineIconsMapping.findIndex( item => item.uid === uid );

		// Remove from the general mapMarkers.
		this.mapMarkers.splice( mapMarkerIndex, 1 );

		// Remove marker from map.
		this.customMarkerMapping[customMarkerIndex].remove();
		this.customMarkerMapping.splice( customMarkerIndex, 1 );

		// Remove lines that came from the marker.
		if ( lineMappingFromIndex in this.linesMapping ) {
			this.linesMapping[lineMappingFromIndex].line.setMap( null );
			this.linesMapping.splice( lineMappingFromIndex, 1 );
		}

		// Remove lines that went to the marker.
		if ( lineMappingToIndex in this.linesMapping ) {
			this.linesMapping[lineMappingToIndex].line.setMap( null );
			this.linesMapping.splice( lineMappingToIndex, 1 );
		}

		// Remove line icons.
		if ( lineIconsMappingIndex in this.lineIconsMapping ) {
			this.lineIconsMapping[lineIconsMappingIndex].remove();
			this.lineIconsMapping.splice( lineIconsMappingIndex, 1 );
		}

		this.redrawLines();
	},

	createCustomMarker( args = {} ) {
		class CustomMarker extends google.maps.OverlayView {
			constructor( args = {} ) {
				super();
				this.instance = args.instance;
				this.position = args.position;
				this.title = args.title || '';
				this.titlePosition = args.titlePosition || 'top-left';
				this.subtitle = args.subtitle || '';
				this.hideMarker = args.hideMarker || false;
				this.hideTitle = args.hideTitle || false;
				this.icon = args.icon;
				this.iconRotation = args.iconRotation;
				this.iconFlip = args.iconFlip;
				this.div = null;
				this.setMap( args.map );
				this.uid = args.uid;
				this.divClasses = args.divClasses || [];
				this.iconClasses = args.iconClasses || [];
				this.iconOffsetX = args.iconOffsetX || 0;
				this.iconOffsetY = args.iconOffsetY || 0;
				this.editing = args.editing || false;
			}

			onAdd() {
				const div = document.createElement( 'div' );
				div.className = 'era-map-marker ' + this.divClasses.join( ' ' );
				this.div = div;

				// Create the label
				const label = document.createElement( 'div' );
				label.className = 'era-map-marker-label';
				label.setAttribute( 'data-position', this.titlePosition );
				label.textContent = this.title;
				div.appendChild( label );

				this.setHideMarker( this.hideMarker );
				this.setHideTitle( this.hideTitle );
				this.setEditingMarker( this.editing );

				const subtitle = this.getSubtitleMarkup();
				if ( subtitle ) {
					label.appendChild( subtitle );
				}

				// Add the SVG if it's not empty
				if ( this.icon ) {
					div.appendChild( this.getIconMarkup() );
				}

				const panes = this.getPanes();
				panes.overlayMouseTarget.appendChild( div );
			}

			getIconMarkup() {
				const iconElement = document.createElement( 'div' );
				iconElement.className = 'era-map-marker-icon ' + this.iconClasses.join( ' ' );
				iconElement.setAttribute( 'data-flip', this.iconFlip );
				iconElement.style.setProperty( 'rotate', this.iconRotation + 'deg' );
				iconElement.setAttribute( 'data-position', 'custom' );
				iconElement.style.setProperty( '--icon-offset-x', this.iconOffsetX + 'px' );
				iconElement.style.setProperty( '--icon-offset-y', this.iconOffsetY + 'px' );
				// const iconData = this.instance.data.icons[this.icon];
				const iconData = this.icon;

				// iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${iconData.viewbox}"><path d="${iconData.svg_path}"/></svg>`;
				iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><use xlink:href="${this.instance.data.svgSprite}#${iconData}"/></use></svg>`;
				return iconElement;
			}

			getSubtitleMarkup() {
				if ( this.subtitle !== '' ) {
					const subtitleElement = document.createElement( 'span' );
					subtitleElement.className = 'era-map-marker-label__subtitle';
					subtitleElement.textContent = this.subtitle;
					return subtitleElement;
				}
				return false;
			}

			setPosition( newPosition ) {
				this.position = newPosition;
				this.draw();
			}

			setTitle( newTitle ) {
				this.title = newTitle;
				if ( this.div ) {
					this.div.querySelector( '.era-map-marker-label' ).textContent = newTitle;
				}
			}

			setTitlePosition( newTitlePosition ) {
				this.titlePosition = newTitlePosition;
				if ( this.div ) {
					this.div.querySelector( '.era-map-marker-label' ).setAttribute( 'data-position', newTitlePosition );
				}
			}

			setSubtitle( value ) {
				this.subtitle = value;
				if ( this.div ) {
					const label = this.div.querySelector( '.era-map-marker-label' );
					let subtitle = label.querySelector( '.era-map-marker-label__subtitle' );
					if ( subtitle && this.subtitle !== '' ) {
						subtitle.textContent = this.subtitle;
					} else if ( subtitle && this.subtitle === '' ) {
						subtitle.remove();
					} else if ( ! subtitle && this.subtitle !== '' ) {
						subtitle = this.getSubtitleMarkup();
						label.appendChild( subtitle );
					}
				}
			}

			setHideMarker( value ) {
				this.hideMarker = value;
				if ( this.div ) {
					const hide = this.hideMarker ? 'true' : 'false';
					this.div.setAttribute( 'data-hide', hide );
				}
			}

			setHideTitle(value ) {
				this.hideTitle = value;
				if ( this.div ) {
					const hide = this.hideTitle ? 'true' : 'false';
					this.div.setAttribute( 'data-hide-title', hide );
				}
			}

			setEditingMarker( value ) {
				this.editing = value;
				if ( this.div ) {
					const editing = this.editing ? 'true' : 'false';
					this.div.setAttribute( 'data-editing', editing );
				}
			}

			setIcon( newIcon ) {
				this.icon = newIcon;
				if ( this.div ) {
					const icon = this.div.querySelector( '.era-map-marker-icon' );
					if ( icon ) {
						icon.remove();
					}
					if ( newIcon !== '' ) {
						this.div.appendChild( this.getIconMarkup() );
					}
				}
			}

			setIconRotation( newRotation ) {
				this.iconRotation = newRotation;
				if ( this.div ) {
					const icon = this.div.querySelector( '.era-map-marker-icon' );
					if ( icon ) {
						icon.style.setProperty( 'rotate', this.iconRotation + 'deg' );
					}
				}
			}

			setIconFlip( shouldFlip ) {
				this.iconFlip = shouldFlip;
				if ( this.div ) {
					const icon = this.div.querySelector( '.era-map-marker-icon' );
					if ( icon ) {
						const flip = shouldFlip ? 'true' : 'false';
						icon.setAttribute( 'data-flip', flip );
					}
				}
			}

			setIconOffset( x, y ) {
				this.iconOffsetX = x;
				this.iconOffsetY = y;
				if ( this.div ) {
					const icon = this.div.querySelector( '.era-map-marker-icon' );
					if ( icon ) {
						icon.setAttribute( 'data-position', 'custom' );
						icon.style.setProperty( '--icon-offset-x', x + 'px' );
						icon.style.setProperty( '--icon-offset-y', y + 'px' );
					}
				}
			}

			draw() {
				if ( this.div ) {
					const overlayProjection = this.getProjection();
					const pos = overlayProjection.fromLatLngToDivPixel( this.position );

					this.div.style.left = `${pos.x}px`;
					this.div.style.top = `${pos.y}px`;
					this.div.style.position = 'absolute';
				}
			}

			remove() {
				this.setMap( null );
			}

			onRemove() {
				if ( this.div ) {
					this.div.parentNode.removeChild( this.div );
					this.div = null;
				}
			}
		}

		return new CustomMarker( args );
	},

	/**
	 * Find a point on the 500 point bezier curve by a percentage.
	 * So for 50%, the index is 250. An input range setting between 0 and 100 can then decide
	 * where on the curved path the icon should be placed.
	 *
	 * @param path
	 * @param percentage
	 * @returns {*}
	 */
	getPointByPercentage( path, percentage ) {
		const clamped = Math.max( 0, Math.min( percentage, 100 ) );
		const index = Math.round( (clamped / 100) * (path.length - 1) );
		return path[index];
	},

	/**
	 * Create a 500 point bezier curve from start and end coordinates
	 * @param args
	 * @returns {*[]}
	 */
	createBezierCurve( args ) {
		const startLat = parseFloat( args.start.lat );
		const startLng = parseFloat( args.start.lng );
		const endLat = parseFloat( args.end.lat );
		const endLng = parseFloat( args.end.lng );

		const midLat = (startLat + endLat) / 2;
		const midLng = (startLng + endLng) / 2;

		const deltaLat = endLat - startLat;
		const deltaLng = endLng - startLng;

		const scale = args.curve;
		const offsetLat = -deltaLng * scale;
		const offsetLng = deltaLat * scale;

		const controlPoint = {
			lat: midLat + offsetLat,
			lng: midLng + offsetLng
		};

		const steps = 500;
		const path = [];

		for ( let t = 0; t <= 1; t += 1 / steps ) {
			const lat = (1 - t) * (1 - t) * startLat + 2 * (1 - t) * t * controlPoint.lat + t * t * endLat;
			const lng = (1 - t) * (1 - t) * startLng + 2 * (1 - t) * t * controlPoint.lng + t * t * endLng;

			path.push( { lat, lng } );
		}

		return path;
	},

	/**
	 * Get map options.
	 * @returns {{zoom, center: {lat: (number|*), lng: (number|*)}, disableDefaultUI: boolean, zoomControl: boolean, styles: [{featureType: string, elementType: string, stylers: [{visibility: string}]},{featureType: string, elementType: string, stylers: [{color: string}]},{featureType: string, elementType: string, stylers: [{color: string}]},{featureType: string, elementType: string, stylers: [{color: string},{weight: number},{visibility: string}]}]}}
	 */
	getMapOptions() {
		return {
			zoom: this.mapSettings.zoom,
			center: {
				lat: this.mapSettings.centerLat,
				lng: this.mapSettings.centerLng
			},
			disableDefaultUI: true,
			zoomControl: this.isBuilder,
			styles: [
				{
					"featureType": "administrative.country",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#575757"
						},
						{
							"weight": 0.5
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#a1a1a1"
						}
					]
				},
				{
					"featureType": "poi.business",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.government",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.medical",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.place_of_worship",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.school",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				}
			]
		};
	}
};

document.addEventListener( 'DOMContentLoaded', () => {
	whenMapsReady()
		.then( () => window.eraGoogleMaps.initFrontend() )
		.catch( () => {
			// It’s okay if the loader isn’t present on some pages.
		} );
} );
